import { createFileRoute } from "@tanstack/react-router";
import PrivateListingMethod from "@/pages/PrivateListingMethod";

export const Route = createFileRoute("/vinde-masina/metoda/")({
  head: () => ({
    meta: [
      { title: "Alege cum îți creezi anunțul auto | RO Auto Market" },
      {
        name: "description",
        content:
          "Completezi anunțul manual sau lași AI-ul să îl creeze din videoclipul mașinii tale. Verifici totul înainte de publicare.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Alege cum îți creezi anunțul auto" },
      {
        property: "og:description",
        content: "Listare manuală sau creare din video cu AI, după pachetul ales.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PrivateListingMethod,
});
